<div class="w-5 h-5 rounded-full" [style.background]="colorMap(colorName)">
    <div class="w-5 h-5 rounded-full" [style.background]="colorMap(colorName)" [class.animate-ping]="ping"> </div>
</div>